import React from 'react'
import { AnalyticsLogger } from './AnalyticsLogger'
import { GtmAnalyticsLogger } from './GtmAnalyticsLogger'

export const AnalyticsContext = React.createContext<AnalyticsLogger>(new GtmAnalyticsLogger())